import styled from 'styled-components';
import Button from 'components/Button';

export const CustomButton = styled(Button)``;
export const CustomModalButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
`;
